var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "提示文字" } },
        [
          _c("el-input", {
            attrs: { size: "small", placeholder: "开始日期提示" },
            model: {
              value: _vm.value.placeholder[0],
              callback: function ($$v) {
                _vm.$set(_vm.value.placeholder, 0, $$v)
              },
              expression: "value.placeholder[0]",
            },
          }),
          _c("el-input", {
            attrs: { size: "small", placeholder: "结束日期提示" },
            model: {
              value: _vm.value.placeholder[1],
              callback: function ($$v) {
                _vm.$set(_vm.value.placeholder, 1, $$v)
              },
              expression: "value.placeholder[1]",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "日期格式" } },
        [
          _c(
            "el-select",
            {
              staticClass: "width-100",
              attrs: { size: "small" },
              model: {
                value: _vm.value.format,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "format", $$v)
                },
                expression: "value.format",
              },
            },
            [
              _c("el-option", {
                attrs: { value: "yyyy-MM-dd", label: "年-月-日" },
              }),
              _c("el-option", {
                attrs: {
                  value: "yyyy-MM-dd HH:mm:ss",
                  label: "年-月-日 时:分:秒",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "radio-group-total", attrs: { label: "累计时间" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.totalType,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "totalType", $$v)
                },
                expression: "value.totalType",
              },
            },
            [
              _c("el-radio", { attrs: { label: "none" } }, [
                _c("span", { staticClass: "name-text" }, [_vm._v("不显示")]),
              ]),
              _c("el-radio", { attrs: { label: "day" } }, [
                _c("span", { staticClass: "name-text" }, [_vm._v("统计天数")]),
              ]),
              _c("el-radio", { attrs: { label: "hour" } }, [
                _c("span", { staticClass: "name-text" }, [_vm._v("统计小时")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }